module.exports = __webpack_public_path__ + "01_short_brown.b8651647.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/01_short_brown.png
// module id = q/zT
// module chunks = 0